import type { ClientLogRelay } from '~/interfaces/ClientLogRelay'

export function flushClientLogRelayOnPageExit(
  relay: ClientLogRelay,
  win: Pick<Window, 'addEventListener'>,
  doc: Pick<Document, 'addEventListener' | 'visibilityState'>
): void {
  win.addEventListener('pagehide', () => {
    relay.flush(true)
  })
  doc.addEventListener('visibilitychange', () => {
    if (doc.visibilityState === 'hidden') relay.flush(true)
  })
}
